import React from 'react';
import * as Sentry from '@sentry/browser';
import { Information } from '@piwikpro/ui-components';

interface State {
  hasError: boolean
}

export default <T extends Record<string, any>>(WrappedComponent: React.ComponentType<T>) => (
  class ErrorBoundary extends React.Component<T, State> {
    constructor(props: T) {
      super(props);

      this.state = {
        hasError: false,
      };
    }

    static getDerivedStateFromError() {
      return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
      Sentry.withScope((scope) => {
        scope.setExtras(errorInfo as any);
      });
    }

    render() {
      const { hasError } = this.state;

      if (hasError) {
        return (
          <div>
            <Information
              dataId="Information"
              type="error"
            >
              Error occurred during Javascript code execution.
              Contact your administration for further assistance.
            </Information>
          </div>
        );
      }

      return <WrappedComponent {...this.props} />;
    }
  }
);
